var _defineProperty = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _PROJECT_TYPES$DEMO, _PROJECT_TYPES$CODING, _ColourSwirl;

var _require = require('../constants'),
    BLOCK_LEVEL_TYPES = _require.BLOCK_LEVEL_TYPES,
    PROJECT_TYPES = _require.PROJECT_TYPES;

var ScratchComingSoonProject = 'ScratchComingSoonProject';
var ScratchDemoLEDcolourSwirlBeginnerProject = 'ScratchDemoLEDcolourSwirlBeginnerProject';
var ScratchDemoLEDcolourSwirlCoreProject = 'ScratchDemoLEDcolourSwirlCoreProject';
var ScratchDemoLEDcolourSwirlAdvancedProject = 'ScratchDemoLEDcolourSwirlAdvancedProject';
var ScratchLEDcolourSwirlBeginnerProject = 'ScratchLEDcolourSwirlBeginnerProject';
var ScratchLEDcolourSwirlCoreProject = 'ScratchLEDcolourSwirlCoreProject';
var ScratchLEDcolourSwirlAdvancedProject = 'ScratchLEDcolourSwirlAdvancedProject';
module.exports = {
  'Colour Swirl': (_ColourSwirl = {}, _defineProperty(_ColourSwirl, PROJECT_TYPES.DEMO, (_PROJECT_TYPES$DEMO = {}, _defineProperty(_PROJECT_TYPES$DEMO, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchDemoLEDcolourSwirlBeginnerProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$DEMO, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchDemoLEDcolourSwirlCoreProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$DEMO, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchDemoLEDcolourSwirlAdvancedProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _PROJECT_TYPES$DEMO)), _defineProperty(_ColourSwirl, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING = {}, _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchLEDcolourSwirlBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchLEDcolourSwirlCoreProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchLEDcolourSwirlAdvancedProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _PROJECT_TYPES$CODING)), _ColourSwirl)
};